import mainRoutes from './main/index'
import homeRoutes from './home/index'
import authRoutes from './auth/index'

const routes = []

mainRoutes.forEach(route => {
  routes.push({
    path: route.path,
    component: () => import('@/layout/MainLayout.vue'),
    children: [route]
  })
})

homeRoutes.forEach(route => {
  routes.push({
    path: route.path,
    component: () => import('@/layout/HomeLayout.vue'),
    children: [route]
  })
})

authRoutes.forEach(route => {
  routes.push({
    path: route.path,
    component: () => import('@/layout/AuthLayout.vue'),
    children: [route]
  })
})

routes.push({
  path: '*',
  redirect: '/domainManage'
})

export default routes
